// extracted by mini-css-extract-plugin
export default {"ticketNextButton":"button_ticketNextButton__6o90I","buttonDisabled":"button_buttonDisabled__-Vb6Y","buttonText":"button_buttonText__1pxwP","button":"button_button__Hv4tV"};